<template>
  <div class="AddsignDialog">
    <el-dialog
      title="治疗信息"
      :visible.sync="isOpenDialog.status"
      width="1205px"
      class="AddsignDialogDialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @close="closeDialog"
      :append-to-body="true"
      :modal-append-to-body="false"
    >
      <div class="navBorder"></div>
      <br />
      <el-form ref="ruleForm" :model="addSign">
        <!-- <el-col :span="12">
          <div class="leftItem">
            <el-col :span="5">
              <p class="rightItemTitle popTitleDialog">标记序号</p>
            </el-col>
            <el-col :span="18">
              <el-form-item prop="beauty_item">
                <el-input
                  class="popInput popInputSingle"
                  v-model="addSign.sign_no"
                  placeholder="请输入内容"
                  placement="top"
                  :disabled="dblLevel!==1&&isReset"
                ></el-input>
              </el-form-item>
            </el-col>
          </div>
        </el-col>-->
        <el-col :span="12">
          <div class="leftItem">
            <el-col :span="5">
              <p class="rightItemTitle popTitleDialog">编号</p>
            </el-col>
            <el-col :span="18">
              <el-row type="flex" class="row-bg" justify="space-between">
                <el-col :span="20">
                  <el-form-item prop="beauty_item">
                    <el-select
                      placeholder="请选择"
                      @change="selectChange4"
                      v-model="addSign.detail_title"
                      class="popInput"
                    >
                      <el-option
                        v-for="item in parameterData"
                        :key="item.id"
                        :label="item.label"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-button
                    class="rightFlex"
                    type="primary"
                    @click.prevent="createSignParameter()"
                  >+</el-button>
                </el-col>
              </el-row>
            </el-col>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="leftItem">
            <el-col :span="5">
              <p class="rightItemTitle popTitleDialog">美容/治疗项目</p>
            </el-col>
            <el-col :span="18">
              <el-form-item prop="beauty_item">
                <el-select
                  placeholder="请选择"
                  @change="selectChange"
                  v-model="addSign.beauty_item"
                  class="popInput"
                >
                  <el-option
                    v-for="item in data"
                    :key="item.id"
                    :label="item.label"
                    :value="item.label"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="leftItem">
            <el-col :span="5">
              <p class="rightItemTitle popTitleDialog">设备治疗/方法</p>
            </el-col>
            <el-col :span="18">
              <el-form-item prop="therapeutic_methods">
                <el-select
                  placeholder="请选择"
                  v-model="addSign.therapeutic_methods"
                  @change="selectChange2"
                  class="popInput"
                >
                  <el-option
                    v-for="item in therapeutic_methods_item"
                    :key="item.value"
                    :label="item.label"
                    :value="item.label"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="leftItem">
            <el-col :span="5">
              <p class="rightItemTitle popTitleDialog">治疗模块</p>
            </el-col>
            <el-col :span="18">
              <el-form-item prop="therapeutic_module">
                <el-select
                  placeholder="请选择"
                  v-model="addSign.therapeutic_module"
                  @change="selectChange3"
                  class="popInput"
                >
                  <el-option
                    v-for="item in therapeutic_module_item"
                    :key="item.value"
                    :label="item.label"
                    :value="item.label"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </div>
        </el-col>
        <br />
        <el-col :span="24">
          <div class="navBorder2"></div>
          <br />
        </el-col>

        <el-col :span="12" v-for="(item,index) in paramList" :key="index">
          <div class="leftItem">
            <el-col :span="5">
              <p class="rightItemTitle popTitleDialog">{{item.label}}</p>
            </el-col>
            <el-col :span="18">
              <el-form-item prop="beauty_item">
                <el-input
                  class="popInput popInputSingle"
                  v-model="item.value"
                  placeholder="请输入内容"
                  placement="top"
                ></el-input>
              </el-form-item>
            </el-col>
          </div>
        </el-col>
        <el-col :span="24">
          <el-row type="flex" justify="end">
            <el-col :span="8">
              <el-col :span="12">
                <el-form-item>
                  <!-- <button
                    @click.prevent="removeData('ruleForm')"
                    class="btn iconfont leftItemSubmit"
                    style="padding: 0"
                  >删除</button>-->
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item>
                  <button
                    @click.prevent="saveData('ruleForm')"
                    class="btn iconfont leftItemSubmit"
                    style="padding: 0"
                  >保存</button>
                </el-form-item>
              </el-col>
            </el-col>
          </el-row>
        </el-col>
      </el-form>
      <CommonAddParameterNumber></CommonAddParameterNumber>
    </el-dialog>
  </div>
</template>
<script>
// import CommonHairdressingForm from "./CommonHairdressingForm.vue";
import getCosmetologyItemTree from "../gql/getCosmetologyItemTree.gql";
import addCosmetologyTreatDetail from "../gql/addCosmetologyTreatDetail.gql";
import getCosmetologyTreatDetail from "../gql/getCosmetologyTreatDetail.gql";
import modifyCosmetologyTreatDetail from "../gql/modifyCosmetologyTreatDetail.gql";
import removeCosmetologyTreatDetail from "../gql/removeCosmetologyTreatDetail.gql";
import getCosmetologyReleInfo from "../gql/getCosmetologyReleInfo.gql";
import checkDetailTitle from "../gql/checkDetailTitle.gql";
import CommonAddParameterNumber from "./CommonAddParameterNumber.vue";
import _ from "lodash";
export default {
  inject: {
    isOpenDialog: ["isOpenDialog"],
    commonData: {
      default: () => {
        return {};
      }
    }
  },
  provide() {
    return {
      addParNumData: this.addParNumData,
      createEmptyParNum: this.createEmptyParNum
    };
  },
  data() {
    return {
      addSign: {
        sign_no: "",
        beauty_item: "",
        therapeutic_methods: "",
        therapeutic_module: "",
        detail_title: "",
        arguments: ""
      },
      data: [],
      theRapies: {},
      dblLevel: "",
      isReset: "",
      rules: [],
      parameterData: [],
      treatMethodOptions: [
        { label: "中西医治疗", id: 0, value: "中西医治疗" },
        { label: "中医治疗", id: 1, value: "中医治疗" },
        { label: "西医治疗", id: 2, value: "西医治疗" }
      ],
      therapeutic_methods_item: [],
      therapeutic_module_item: [],
      paramList: [],
      // id集合
      idArray: {
        beauty_item_id: -1,
        therapeutic_methods_id: -1,
        therapeutic_module_id: -1
      },
      // 保存成功是否刷新数据 （新增成功后刷新detail_title數據）
      isFreshSuccess: false,
      addParNumData: {
        isShowDialog: false,
        detail_title: ""
      }
    };
  },
  computed: {
    dialogStatus() {
      return this.isOpenDialog.status;
    }
  },
  components: {
    CommonAddParameterNumber
  },
  async mounted() {
    if (!_.isEmpty(this.commonData)) {
      await this.getCosmetologyItemTreeData();
      await this.getparameter(
        this.commonData.patientId,
        this.commonData.treat_no
      );
    }
  },
  watch: {
    async "isOpenDialog.status"(val) {
      if (val) {
        // console.log(val);
          if (this.parameterData.length>0){
              this.addSign.detail_title = this.parameterData[0].id
              this.selectChange4(this.parameterData[0].id)
          }
        this.addSign.sign_no = this.isOpenDialog.sign_no;
        // console.log(this.isOpenDialog.signId)
        if (this.isOpenDialog.signId) {
          // console.log(999);
          await this.getCosmetologyItemDetail(this.isOpenDialog.signId);
        }
      }else {
        this.addParNumData.isShowDialog = false;
      }
    },
    "addSign.beauty_item"(val, oldVal) {
      // console.log(val)
      if (!this.isOpenDialog.signId) {
        this.addSign.therapeutic_methods = "";
      } else {
        if (val !== oldVal && oldVal) {
          this.addSign.therapeutic_methods = "";
        }
      }
      // this.therapeutic_methods_item = [];
    },
    "addSign.therapeutic_methods"(val, oldVal) {
      // console.log(val)
      if (!this.isOpenDialog.signId) {
        this.addSign.therapeutic_module = "";
      } else {
        if (val !== oldVal && oldVal) {
          this.addSign.therapeutic_module = "";
        }
      }

      // this.therapeutic_module_item =[];
    },
    "addSign.therapeutic_module"(val, oldVal) {
      // console.log(val)
      if (_.isEmpty(val)) {
        // this.addSign.therapeutic_module ='';
        this.paramList = [];
      } else {
        if (val !== oldVal && oldVal) {
          this.paramList = [];
        }
      }
    },
    "addSign.detail_title"(val) {
      this.isOpenDialog.detail_title = val;
    }
  },
  methods: {
    closeDialog() {
      this.isOpenDialog.status = false;
      this.clearForm();
      this.resetForm();
    },
    clearForm() {
      // sign_no:"",
      //    beauty_item: "",
      //   therapeutic_methods: "",
      //   therapeutic_module: "",
      //   arguments: ""
      this.addSign.detail_title = "";
      this.addSign.sign_no = "";
      this.addSign.beauty_item = "";
      this.addSign.therapeutic_methods = "";
      this.addSign.therapeutic_module = "";
      this.addSign.arguments = "";
    },
    resetForm() {
      this.therapeutic_module_item = [];
      this.therapeutic_methods_item = [];
      this.paramList = [];
    },
    async saveData() {
        console.log(this.isOpenDialog.signId)
        if (this.addSign.detail_title === ""){
            this.$message.error("请输入参数编号");
        } else {
            if (this.isOpenDialog.signId) {
                await this.resetInfo();
            } else {
                await this.addInfo();
            }
        }


    },
    // this.idArray.beauty_item_id  = item.item_id;
    //   this.idArray.therapeutic_methods_id  = item.device_id;
    //   this.idArray.therapeutic_module_id  = item.id;
    async addInfo() {
      const variables = {
        patient_id: this.commonData.patientId,
        // detail_title:'66',
        detail_title: this.addSign.detail_title,
        treat_no: this.commonData.treat_no,
        item_id: this.idArray.beauty_item_id,
        image_id: this.isOpenDialog.imageId,
        sign_no: this.addSign.sign_no,
        device_id: this.idArray.therapeutic_methods_id,
        module_id: this.idArray.therapeutic_module_id,
        param_value: JSON.stringify(this.paramList),
        parent_id: this.commonData.parent_id,
        // total_times: this.commonData.totalNum,
        // current_times: this.commonData.thisNum
      };
      // console.log(variables)
      try {
        const res = await this.$apollo.mutate({
          mutation: addCosmetologyTreatDetail,
          variables
        });
        this.$message({
          type: "success",
          message: "保存成功"
        });
        this.$root.$emit('refresh-par-num-list');
        // this.cosmetologyTreatDetailId = res.data.addCosmetologyTreatDetail.id;
        this.$emit("updateSignId", {
          sqlId: res.data.addCosmetologyTreatDetail.id,
          detail_title: this.addSign.detail_title
        });
        this.isOpenDialog.signId = res.data.addCosmetologyTreatDetail.id;
        // this.isOpenDialog.detail_title =this.addSign.detail_title;
        await this.getparameter(
          this.commonData.patientId,
          this.commonData.treat_no
        );
        this.closeDialog();
      } catch (error) {
        this.$message.error(error.message.split(":")[1]);
      }
    },
    async resetInfo() {
      const variables = {
        id: this.isOpenDialog.signId,
        patient_id: this.commonData.patientId,
        treat_no: this.commonData.treat_no,
        item_id: this.idArray.beauty_item_id,
        image_id: this.isOpenDialog.imageId,
        sign_no: this.addSign.sign_no,
        device_id: this.idArray.therapeutic_methods_id,
        module_id: this.idArray.therapeutic_module_id,
        param_value: JSON.stringify(this.paramList)
      };

      try {
        const res = await this.$apollo.mutate({
          mutation: modifyCosmetologyTreatDetail,
          variables
        });
        this.$message({
          type: "success",
          message: "修改成功"
        });
        this.$root.$emit('refresh-par-num-list');
        this.$emit("updateSignId", {
          sqlId: this.isOpenDialog.signId,
          detail_title: this.addSign.detail_title
        });
        this.closeDialog();
        // this.cosmetologyTreatDetailId = res.data.addCosmetologyTreatDetail.id;
        // this.$emit('updateSignId',{sqlId: res.data.addCosmetologyTreatDetail.id})
      } catch (error) {
        this.$message.error(error.message.split(":")[1]);
      }
    },
    async getCosmetologyItemTreeData() {
      try {
        let res = await this.$apollo.query({
          query: getCosmetologyItemTree,
          fetchPolicy: "no-cache"
        });
        this.data = this.computedTree(res.data.getCosmetologyItemTree);
      } catch (error) {
        console.log(error);
      }
    },
    async getCosmetologyItemDetail(ID) {
      try {
        // console.log(ID)
        let res = await this.$apollo.query({
          query: getCosmetologyTreatDetail,
          variables: {
            id: ID
          },
          fetchPolicy: "no-cache"
        });
        // console.log(res.data.getCosmetologyTreatDetail)
        this.hasIdsetData(res.data.getCosmetologyTreatDetail);
      } catch (error) {
        console.log(error);
      }
    },
    async removeData() {
      try {
        // console.log(ID)
        let res = await this.$apollo.mutate({
          mutation: removeCosmetologyTreatDetail,
          variables: {
            id: this.isOpenDialog.signId
          },
          fetchPolicy: "no-cache"
        });
        // console.log(res.data.removeCosmetologyTreatDetail)
        if (res.data.removeCosmetologyTreatDetail) {
          this.$message.success("数据已刪除");
          this.$emit("updateSignId", {
            sqlId: ""
          });
          this.isOpenDialog.signId = "";
          this.isOpenDialog.status = fasle;
        } else {
          this.$message.success("请重试");
        }
      } catch (error) {
        console.log(error);
      }
    },
    async getparameter(ID, treat_no) {
      try {

        let res = await this.$apollo.query({
          query: getCosmetologyReleInfo,
          variables: {
            patient_id: ID,
            treat_no
          },
          fetchPolicy: "no-cache"
        });

        this.computerTitle(res.data.getCosmetologyReleInfo);
        // if (this.isFreshSuccess) {
        // } else {
        // }
        // this.hasIdsetData(res.data.getCosmetologyTreatDetail);
      } catch (error) {
        console.log(error);
      }
    },
    computerTitle(item) {
      if (!_.isEmpty(item.treat_details)) {
        let paramsList = item.treat_details;
        let newList = [];
        for (let i = 0; i < paramsList.length; i++) {
          let newObj = {};
          newObj.id = paramsList[i].id;
          newObj.label = paramsList[i].detail_title;
          newList.push(newObj);
        }
        this.parameterData = newList;

      }
    },
    // 參數编号查重
    checkTitleRepetition(patient_id, treat_no, detail_title) {
      // try {
      // console.log(ID)
      let res = this.$apollo.mutate({
        mutation: checkDetailTitle,
        variables: {
          patient_id,
          treat_no,
          detail_title
        },
        fetchPolicy: "no-cache"
      });
      return res.data.checkDetailTitle;
      // } catch (error) {
      //   console.log(error);
      //   this.$message.error('请检查网络');
      //   return false;
      // }
    },
    hasIdsetData(item) {
      //  beauty_item: "",
      //   therapeutic_methods: "",
      //   therapeutic_module: "",
      //   arguments: ""
      if (item) {
        // 设置文字
        this.addSign.detail_title = item.detail_title;
        this.addSign.beauty_item = item.item_info.item_name;
        this.addSign.therapeutic_methods = item.device_info.device_name;
        this.addSign.therapeutic_module = item.module_info.module_name;
        // 设置id
        this.idArray.beauty_item_id = item.item_id;
        this.idArray.therapeutic_methods_id = item.device_id;
        this.idArray.therapeutic_module_id = item.module_id;
        // // 设置selectList
        this.paramList = JSON.parse(item.param_value);
        this.selectChange(this.addSign.beauty_item);
        this.selectChange2(this.addSign.therapeutic_methods);
      } else {
        this.$message("请重新绑定标记点信息");
      }
      // this.selectChange3(this.addSign.therapeutic_module);
    },
    computedTree(treeData) {
      if (!_.isEmpty(treeData)) {
        treeData.map(e => {
          e.label = e.item_name;
          e.children = [];
          e.delete = false;
          e.device.map(m => {
            m.label = m.device_name;
            m.node = true;
            m.delete = false;
            m.children = [];
            m.treat_module.map(n => {
              n.label = n.module_name;
              n.node = true;
              n.delete = false;
              n.children = [];
              n.children = [
                {
                  id: n.id,
                  label: n.params,
                  delete: true,
                  dis: true
                }
              ];
            });
            m.children = m.treat_module;
          });
          e.children = e.device;
        });
        return treeData;
      } else {
        return [];
      }
    },
    // beauty_item_id:-1,
    //     therapeutic_methods_id:-1,
    //     therapeutic_module_id:-1,
    selectChange(value) {
        this.therapeutic_module_item =[]

      let item = this.data.find(e => {
        return e.label === value;
      });

      this.idArray.beauty_item_id = item.id;

      // this.addSign.therapeutic_methods ='';
      //  this.therapeutic_methods_item =[]
      if (!_.isEmpty(item.children)) {
        this.therapeutic_methods_item = item.children;
      }

    },
    selectChange2(value) {

      let item = this.therapeutic_methods_item.find(e => {
        return e.label === value;
      });
      this.idArray.therapeutic_methods_id = item.id;
      // this.addSign.therapeutic_module ='';
      //  this.therapeutic_module_item =[]
      if (!_.isEmpty(item.children)) {
        this.therapeutic_module_item = item.children;
      }
    },
    selectChange3(value) {
      let item = this.therapeutic_module_item.find(e => {
        return e.label === value;
      });
      // console.log(this.idArray);
      // this.idArray.beauty_item_id = item.item_id;
      // this.idArray.therapeutic_methods_id = item.device_id;
      this.idArray.therapeutic_module_id = item.id;
      //  this.paramList =[]
      if (!_.isEmpty(item.params)) {
        let paramsList = item.params.split("#");
        let newList = [];
        for (let i = 0; i < paramsList.length; i++) {
          let newObj = {};
          newObj.value = "";
          newObj.label = paramsList[i];
          newList.push(newObj);
        }
        this.paramList = newList;
      }
    },
    async selectChange4(value) {
      // this.addSign.detail_title = '';
      this.addSign.beauty_item = "";
      this.addSign.therapeutic_methods = "";
      this.addSign.therapeutic_module = "";
      this.isOpenDialog.signId = value;

      await this.getCosmetologyItemDetail(value);
    },
    // 自定義序號
    createSignParameter() {
      this.addParNumData.isShowDialog = true;
    },
    createEmptyParNum(numText) {
      console.log(numText)
      this.clearForm();
      this.resetForm();
      this.isOpenDialog.signId = "";
      this.addSign.detail_title = numText;
    }
  }
};
</script>
<style lang="less">
.AddsignDialogDialog {
  /*修改tree插件样式*/
  .my_tree .el-tree-node__content {
    height: auto;
  }
  .my_tree .el-tree-node {
    white-space: pre-wrap;
    padding: 0;
  }
  .my_tree .v-modal {
    z-index: 0 !important;
  }
  .my_tree .el-tree-node__expand-icon {
    margin-left: 6px;
    margin-right: 6px;
    padding: 0;
    font-size: 24px;
    color: #111;
  }
  .my_tree .is-leaf.el-tree-node__expand-icon {
    color: rgba(255, 255, 255, 0);
    display: none;
  }
  .el-tree-node__content:hover {
    background-color: #66b1ff87;
  }
  .el-textarea__inner {
    height: 350px;
    margin: 4px;
    border: 0;
    width: 98%;
    box-sizing: border-box;
  }
  .el-select {
    width: 100%;
  }
  .v-modal {
    z-index: 1 !important;
  }
  .el-button--primary {
    height: 44px;
    float: right;
    span {
      font-size: 30px;
      line-height: 22px;
    }
  }
}
</style>
<style lang="less">
.AddsignDialogDialog {
  .el-dialog__title {
    color: #4da3c0 !important;
    font-size: 20px;
    font-weight: 600;
  }
  .el-dialog__close {
    color: #4da3c0 !important;
    font-size: 26px;
    font-weight: 700;
  }
  .el-dialog__body {
    padding: 0 20px 30px;
  }
  .el-dialog {
    margin-top: 0 !important;
  }
  .el-input__inner {
    border-radius: 8px;
    height: 46px;
    color: #6b6b6b;
    font-size: 18px;
  }
  .el-input__prefix {
    left: 250px;
    i {
      font-size: 35px !important;
      color: #797979;
    }
  }
  .el-input--prefix .el-input__inner {
    padding-left: 15px;
  }
  .el-input__icon {
    line-height: 46px;
  }
  .el-input__suffix-inner {
    i {
      font-size: 30px !important;
      color: #797979 !important;
    }
  }
  .el-input__suffix {
    right: 10px !important;
  }
  .el-button--primary {
    border-radius: 6px;
  }
  .dialog-pic .el-dialog__header {
    padding-bottom: 28px;
  }
  .themeColor {
    color: #4da3c0 !important;
  }
  .textareas {
    height: 619px !important;
  }
}
</style>
<style lang="less" scoped>
.AddsignDialogDialog {
  .popTitleDialog {
    font-size: 16px;
    font-weight: 600;
    color: black;
    margin-bottom: 15px;
    margin-top: 15px;
    text-indent: 12px;
  }
  // .dialog {
  min-width: 1205px;
  display: flex;
  align-items: center;
  .navBorder {
    width: 100%;
    height: 2px;
    background: #4da3c0;
  }
  .navBorder2 {
    width: 98%;
    height: 2px;
    background: #d9d9d9;
    margin: 0 auto;
  }
  // }
  .main {
    width: 100%;
    display: flex;
    padding: 0 16px;
    box-sizing: border-box;
    justify-content: space-between;
    .popInput {
      // width: 294px;
      border: 1px solid #c0c0c0 !important;
      border-radius: 8px;
      height: 48px;
      box-sizing: border-box;
    }
    .left {
      width: 650px;
      display: inline-block;

      .popInputSingle {
        width: 619px !important;
      }
      .leftItemSubmit {
        width: 298px;
        height: 42px !important;
        margin-top: 34px;
      }
      .isBW {
        display: flex;

        .isBWItem {
          flex: 1;
          font-size: 20px !important;
          font-weight: 600;
        }
        .activeBW {
          background: white;
          color: black;
        }
      }
    }
    .right {
      display: inline-block;
      .rightItem {
        .rightItemContent {
          position: relative;
          border: 10px solid white;
          width: 475px;
          height: 333px;
          border-radius: 20px;
          display: flex;
          justify-content: center;
          align-items: center;
          box-sizing: border-box;
          .images-wrap {
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            box-sizing: border-box;
            background-color: rgb(235, 235, 235);
            padding: 10px 5px 10px 20px;
            overflow-y: auto;
            .images-list {
              display: flex;
              flex-wrap: wrap;
              width: 100%;
              .image-item {
                width: 135px;
                height: 135px;
                margin-right: 4px;
                margin-bottom: 8px;
                background-repeat: no-repeat;
                background-size: cover;
                background-position: center center;
              }
              .image-item:nth-child(3n) {
                margin-right: 0;
              }
            }
            .add-btn {
              display: flex;
              justify-content: center;
              align-items: center;
              color: #fff;
              width: 414px;
              height: 60px;
              border: 3px dashed #fff;
              box-sizing: border-box;
              font-size: 22px;
              cursor: pointer;
            }
          }
          .rightItemIcon {
            font-size: 165px;
            color: white;
          }
        }
      }
      .inpatInput,
      .outpatInput {
        display: none;
      }
    }
  }
}
.icon-wrapper {
  position: fixed;
  width: 100px;
  background-color: rgb(97, 161, 191);
  border-radius: 3px;
  overflow: hidden;
  z-index: 2;
  .btn-item {
    display: flex;
    justify-content: center;
    align-items: center;
    color: #ffffff;
    font-size: 16px;
    height: 30px;
    cursor: pointer;
    user-select: none;
  }
  .btn-item.iconfont {
    font-size: 20px;
  }
  .btn-item.active {
    color: rgb(216, 30, 6);
  }
  .btn-item + .btn-item {
    border-top: 1px solid #ffffff;
  }
  .btn-item:hover {
    background-color: rgb(65, 126, 191);
  }
}
.right {
  width: calc(~"100% - 650px") !important;
}
.rightBox {
  width: 100%;
  height: calc(~"100% - 50px");
  border: 2px solid rgb(206, 210, 218);
  border-radius: 8px;
  background: white;
  box-sizing: border-box;
  padding: 20px;
}
.leftBox {
  width: 619px !important;
  height: 360px;
  border: 2px solid rgb(206, 210, 218);
  border-radius: 8px;
  background: white;
  box-sizing: border-box;
}
.rightInput {
  margin-bottom: 20px;
}
</style>
